import { render, staticRenderFns } from "./BookingAdmin.vue?vue&type=template&id=e710cde6&"
import script from "./BookingAdmin.vue?vue&type=script&lang=js&"
export * from "./BookingAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BookingAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports